// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"553":"e79148c0","977":"f7ef7f34"}[chunkId] + ".chunk.js";
};